import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import db from "../Firebase.js";

export type AgentActivityInput = {
    userName: string;
    parent?: string;
    activity: string;
    customer?: string;
    detail?: string;
};

/**
 * Important admin actions only (transactions, limits, creating accounts).
 * Page visits stay on userActivity / IP tracker.
 *
 * Extra fields:
 * - customer: account the action was applied to
 * - detail: amount or what changed
 */
export async function logAgentActivity(entry: AgentActivityInput): Promise<void> {
    const userName = entry.userName?.trim();
    const activity = entry.activity?.trim();
    if (!userName || !activity) return;

    try {
        await addDoc(collection(db, "agentActivity"), {
            userName,
            parent: entry.parent?.trim() || "",
            activity,
            customer: entry.customer?.trim() || "",
            detail: entry.detail?.trim() || "",
            date: serverTimestamp(),
        });
    } catch (error) {
        console.error("agentActivity log failed:", error);
    }
}
